module.exports = __webpack_public_path__ + "static/media/search--v1.690e7aa6.png";